<div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
  <mat-icon>remove_circle_outline</mat-icon>
</div>

<div>
  <div class="description">
    <strong>Document Rejected </strong>
    {{ activity.meta.document.title }} was rejected by Ocrolus and could not be verified
  </div>
</div>
